/** Right-facing tern silhouette; keep in sync with assets/brand/tern-mark.svg. */
export function TernMark({ className = "h-5 w-5" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 512 512"
      className={className}
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M492 351 L436 336 C417 318 397 318 375 326 C386 291 430 260 441 224 C456 176 414 86 352 30 C374 116 390 175 367 211 C357 229 342 244 326 255 C239 207 135 170 24 144 C109 196 180 237 220 274 C241 294 249 314 254 328 C191 348 115 357 24 365 L234 362 C278 383 321 391 366 373 C395 362 415 354 436 347 Z" />
    </svg>
  );
}
